/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorStatisticsItemModelSchema } from "./authorStatisticsItemModelSchema.ts";
import { trackTypeEnumSchema } from "./trackTypeEnumSchema.ts";
import { z } from "zod";

export const trackStatisticsItemModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор трека"),
"name": z.string().describe("Наименование трека"),
"authors": z.array(z.lazy(() => authorStatisticsItemModelSchema)).describe("Авторы").nullable().nullish(),
"type": z.lazy(() => trackTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Sermon</b>: Проповедь</li>\n<li><b>4 - Book</b>: Аудиокнига</li>\n<li><b>5 - Jingle</b>: Джингл</li>\n</ul>\n"),
"listensCount": z.number().int().describe("Число прослушиваний (включений трека, без учета процента прослушивания)"),
"listensCount50": z.number().int().describe("Число прослушиваний (когда прослушано более 50% трека)"),
"listensCount75": z.number().int().describe("Число прослушиваний (когда прослушано более 75% трека)"),
"listensCount95": z.number().int().describe("Число прослушиваний (когда прослушано более 95% трека)"),
"sharesCount": z.number().int().describe("Сколько раз делились треком"),
"searchesCount": z.number().int().describe("Сколько раз трек запускали из поиска"),
"swapsCount": z.number().int().describe("Сколько раз трек переключали"),
"likesCount": z.number().int().describe("Сколько раз трек лайкали"),
"dislikesCount": z.number().int().describe("Сколько раз трек дизлайкали"),
"playlistsCount": z.number().int().describe("Сколько раз добавляли в плейлист")
    })